module.exports = __webpack_public_path__ + "media/rain.90cecb0f.wav";